import actions from "../../constants/actions";

const initialState = {
    data: [],
    isLoading: false,
    isAdding: false,
    isDeleting: false,
    error: null,
};

export default function spaceReservations(state = initialState, action) {
    switch (action.type) {
        case actions.SPACE_RESERVATIONS.LOAD_LIST:
            return { ...state, isLoading: true };
        case actions.SPACE_RESERVATIONS.LOAD_LIST_SUCCESS:
            return {
                ...state,
                data: action.payload.result.data,
                isLoading: false,
                error: null,
            };
        case actions.SPACE_RESERVATIONS.LOAD_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };

        case actions.SPACE_RESERVATIONS.CREATE:
            return { ...state, isAdding: true };
        case actions.SPACE_RESERVATIONS.CREATE_SUCCESS:
            let createData = state.data.slice();
            createData.push(action.payload.result.data);
            return {
                ...state,
                data: createData,
                isAdding: false,
                error: null,
            };
        case actions.SPACE_RESERVATIONS.CREATE_FAIL:
            return {
                ...state,
                isAdding: false,
                error: action.payload,
            };

        case actions.SPACE_RESERVATIONS.DELETE_SLOT:
            return { ...state, isDeleting: true };
        case actions.SPACE_RESERVATIONS.DELETE_SLOT_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                error: null,
            };
        case actions.SPACE_RESERVATIONS.DELETE_SLOT_FAIL:
            return {
                ...state,
                isDeleting: false,
                error: action.payload,
            };

        case actions.SPACE_RESERVATIONS.DELETE:
            return { ...state, isDeleting: true };
        case actions.SPACE_RESERVATIONS.DELETE_SUCCESS:
            let deleteData = state.data.slice();

            let index = deleteData.indexOf(action.payload);
            if (index > -1) {
                deleteData.splice(index, 1);
            }
            return {
                ...state,
                data: deleteData,
                isDeleting: false,
                error: null,
            };
        case actions.SPACE_RESERVATIONS.DELETE_FAIL:
            return {
                ...state,
                isDeleting: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
